import { Typography } from "@material-ui/core"

const NCText = props => {
  const { component, block, ...rest } = props
  return <Typography component={component || (block ? "div" : "span")} {...rest} />
}

export default NCText
